import styled, { css, keyframes } from 'styled-components';

const animation = keyframes`
    0% {
        box-shadow: 0 0 0 0 #1cc67f;
        opacity: 0.45;
    }
    40% {
        opacity: 0.45;
    }
    100% {
        box-shadow: 0 0 0 9px #1cc67f;
        opacity: 0;
    }
`;

export const CircleButton = styled.div<{ pulse?: boolean; width?: string }>`
  height: 48px;
  width: ${(props) => props.width || '48px'};
  background: #1cc67f;
  box-shadow: 0 12px 24px rgba(57, 78, 127, 0.2);
  border-radius: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  > * {
    z-index: 1000;
  }
  ${(props) =>
    props.pulse &&
    css`
      &:after {
        content: '';
        background-color: inherit;
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: inherit;
        z-index: 0;
        animation: ${animation} infinite 2.6s 0s linear;
        animation-delay: 1.3s;
      }
      &:before {
        content: '';
        background-color: inherit;
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: inherit;
        z-index: 0;
        animation: ${animation} infinite 2.6s 0s linear;
        animation-delay: 0s;
      }
    `}
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100vh;
  z-index: 1000;
  overflow: auto;
`;

export const Wrap = styled.div`
  background: #ffffff;
  box-shadow: 0px 12px 24px rgba(57, 78, 127, 0.2);
  border-radius: 16px;
  overflow: hidden;
  width: 608px;
  /* margin: 128px 0 0 0; */
  position: absolute;
  max-height: 590px;
  height: calc(100% - 28px);
`;

export const Header = styled.div`
  background: #1cc67f;
  padding: 24px;
  box-sizing: border-box;
  width: 100%;
  color: #ffffff;
  font-size: 18px;
  line-height: 24px;
  display: flex;
`;

export const Content = styled.div`
  padding: 32px 24px;
  box-sizing: border-box;
  overflow: auto;
  height: calc(100% - 96px);
`;

export const FieldFlexRow = styled.div`
  display: flex;
  align-items: center;
`;

export const SuccessWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  height: 190px;
  > * {
    flex: 0 0 auto;
  }
`;

export const PolicyLink = styled.a`
  color: #1cc67f;
  outline: none;
  &:active,
  &:focus,
  &:hover,
  &:visited {
    color: #1cc67f;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  padding: 0 16px;
`;

export const FeedbackButtonText = styled.p`
  color: #fff;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
`;

export const UploadFileButton = styled.button<{ isDisabled?: boolean }>`
  display: flex;
  width: 240px;
  height: 48px;
  padding: 10px 20px 10px 15px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 2px solid ${(props) => (props.isDisabled ? '#D9D9D9' : '#1CC67F')};
  background: #ffffff;
  flex-shrink: 0;

  & > * {
    ${(props) => (props.isDisabled ? 'color: #D9D9D9 !important' : 'color: #1CC67F')};
  }

  &:hover {
    background: ${(props) => (props.isDisabled ? '#FFFFFF' : 'rgba(28, 198, 127, 0.2)')};
  }
`;

export const UploadButtonText = styled.span`
  color: #1cc67f;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px; /* 137.5% */
  letter-spacing: 0.64px;
  text-transform: uppercase;
`;
